import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-右箭头",
  "use": "icon-右箭头-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-右箭头\"><defs><style type=\"text/css\"></style></defs><path d=\"M78.62272 549.86752l733.55264 0-187.32032 180.33152a12.288 12.288 0 0 0 0 17.37216l37.632 37.62688a12.288 12.288 0 0 0 17.37216 0l235.8016-227.01568a8.192 8.192 0 0 0 0.79872-0.72192l1.25952-1.25952 36.37248-35.00544c2.56-2.57024 3.7376-5.9904 3.5584-9.35424a12.23168 12.23168 0 0 0-3.5584-9.37472l-37.632-36.27008a13.37856 13.37856 0 0 0-0.74752-0.68096l-235.84768-227.05152a12.288 12.288 0 0 0-17.37216 0l-37.632 37.632a12.288 12.288 0 0 0 0 17.37216l185.56928 178.6368L78.62784 472.10496a12.27264 12.27264 0 0 0-12.27776 12.27776L66.35008 537.6a12.27776 12.27776 0 0 0 12.27776 12.27776l-0.00512-0.01024z\" fill=\"\" p-id=\"4609\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/右箭头.svg
// module id = AJ/P
// module chunks = 12